<app-share-button></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Introduction to PayG</h2>
                </div>
                <div class="col-md-2 col2">
                    <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img
                                src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')" alt=""> </button>
                    </a>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/7V_om-dK_mU"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="6">
                    <h2>Introduction to PayG: </h2>


                    <label for="" class="spn mt-2">PAYG is an Indian financial
                        technology company
                        that
                        provides online payment solutions for businesses of all sizes. Founded in
                        2020,
                        PayG aims to simplify the process of accepting online payments and making
                        transactions easier for all types of businesses in India. PayG works with
                        businesses to provide customized payment solutions that align with their
                        specific requirements. This flexibility allows businesses to enhance the
                        payment
                        experience for their customers. </label>
                    <label for="" class="spn mt-1">PayG has gained popularity in the
                        Indian market
                        due
                        to its user-friendly interface, competitive pricing, and the convenience it
                        offers to businesses and customers alike. It has become a preferred payment
                        gateway for startups, small businesses, and large enterprises looking for
                        reliable and efficient payment processing solutions in India. </label>
                    <label for="" class="spn mt-2">PayG has played a significant
                        role in driving the
                        adoption of digital payments in India. It has contributed to the growth of
                        e-commerce and online transactions by offering a secure, reliable, and
                        user-friendly platform for businesses to manage their payments effectively.
                    </label>
                    <label for="" class="spn mt-2">PAYG is an Indian-based online
                        payment gateway.
                        It
                        offers a platform that enables merchants to make secure online payments and
                        pay
                        bills conveniently. </label>

                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="7">
                    <h2>Key features and offerings of PayG: </h2>
                    <ul class="mt-3">
                        <li class="mt-2">
                            It provides a robust payment gateway that allows businesses to accept
                            online
                            payments through various methods, including credit and debit cards, net
                            banking, UPI, digital wallets, and more.
                        </li>
                        <li class="mt-2">
                            PayG also supports subscription-based billing models, allowing
                            businesses to
                            set up recurring payments for services and products that require
                            periodic
                            payments.
                        </li>
                        <li class="mt-2">
                            The platform also offers tools to generate and manage invoices, making
                            it
                            easier for businesses to handle billing and track payment status.
                        </li>
                        <li class="mt-2">
                            PayG prioritizes security and compliance. It is compliant with Payment
                            Card
                            Industry Data Security Standard (PCI DSS) Level 1 and uses encryption
                            and
                            other security measures to protect sensitive data.
                        </li>
                        <li class="mt-2">
                            The platform offers real-time analytics and insights, providing
                            businesses
                            with valuable data on transactions, customer behavior, and other
                            performance
                            metrics.
                        </li>
                        <li class="mt-2">
                            PayG prioritizes the security of online transactions and employs various
                            security measures, such as encryption and secure socket layer (SSL)
                            technology, to safeguard customer data during payment processing.
                        </li>
                        <li class="mt-2">
                            PayG provides customer support to address any queries or issues related
                            to
                            payments or bill payments, ensuring a smooth user experience.
                        </li>
                    </ul>


                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" id="8"
                    (mouseout)="showpayment(false,'4')">
                    <h2>How PayG is Contributing to India's Digital Growth. </h2>
                    <label for="" class="mt-3">PayG, as a prominent Payment Gateway
                        company, plays a
                        pivotal role in contributing to the growth and development of India's
                        digital
                        economy. Here are some ways in which PayG is helping India:

                    </label>
                    <label for="" class="mt-4"><b>Financial Inclusion:</b>&nbsp;
                        PayG facilitates
                        financial inclusion by providing a platform for businesses, including those
                        in
                        remote or underserved areas, to participate in digital transactions. This
                        broadens access to financial services and promotes economic inclusivity.
                    </label>
                    <label for="" class="mt-4"><b>Supporting Small and Medium
                            Enterprises
                            (SMEs):</b>&nbsp; PayG empowers small and medium enterprises by offering
                        a
                        secure and efficient means to accept digital payments. This not only
                        enhances
                        the credibility of these businesses but also contributes to their growth in
                        the
                        digital marketplace. </label>
                    <label for="" class="mt-4"><b>E-commerce Growth: </b>&nbsp;The
                        seamless
                        integration
                        of PayG into e-commerce platforms supports the thriving online marketplace
                        in
                        India. By providing a reliable and secure payment gateway, PayG facilitates
                        smoother transactions for businesses and enhances the overall e-commerce
                        experience for consumers. </label>
                    <label for="" class="mt-4"><b>Enhancing User Experience:
                        </b>&nbsp;PayG focuses
                        on
                        providing a user-friendly interface and a secure payment environment. This
                        commitment to a positive user experience contributes to building trust in
                        digital transactions and encourages more individuals to adopt cashless
                        payment
                        methods. </label>
                    <label for="" class="mt-4"><b>Digital India
                            Initiative:</b>&nbsp; PayG aligns
                        with
                        the Digital India initiative by promoting the use of digital payment
                        methods.
                        This supports the government's vision of a digitally empowered society and
                        economy, reducing dependency on cash transactions. </label>
                    <label for="" class="mt-4"><b>Fraud Prevention and
                            Security:</b>&nbsp; PayG
                        employs
                        advanced security measures to protect users from fraudulent activities. By
                        ensuring the integrity of digital transactions, PayG contributes to building
                        a
                        secure financial ecosystem. </label>
                    <label for="" class="mt-4"><b>Educational and Healthcare
                            Transactions:</b>&nbsp;
                        PayG supports online payments in the education and healthcare sectors,
                        making it
                        easier for individuals to pay tuition fees, medical bills, and other related
                        expenses. This contributes to the accessibility and efficiency of essential
                        services. </label>
                    <label for="" class="mt-4"><b>Government Services:</b>&nbsp;
                        PayG's role extends
                        to
                        supporting digital transactions for government services, including tax
                        payments
                        and other official transactions. This aligns with the government's push for
                        a
                        more efficient and transparent governance system. </label>
                    <label for="" class="mt-4">PayG's presence in the Indian market
                        positively
                        impacts
                        various sectors. The company's commitment to providing secure, efficient,
                        and
                        user-friendly payment solutions contributes to the ongoing digital
                        transformation in India. </label>
                </div>
            </div>

        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover" [ngClass]="{'video':colors=='1'}"
                                    (click)="color('1')">
                                    Introduction to PayG </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#6">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">

                                    Introduction to
                                    PayG </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#7">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')"> Key
                                    features
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#8">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    How PayG is helping India </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/PayG Overview.pdf" target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    PayG </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/PayG Overview.pdf" download><img src="./assets/Downlod iconn.svg" alt=""
                                    width="100%"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <!-- <a [routerLink]="['/payment-gateway-working']"> <button class="btn  btn-color text-white"
                        (click)="menues('Payment Gateway Working')">
                        <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Payment Gateway Industry's Working
                    </button></a> -->

            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/features']"> <button class="btn btn-color text-white"
                        (click)="menues('features')">Payg feature
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>